import { AdviseEngagement, AdviseFeatureResponse, AdviseSupplier, MatrixFeature } from '../../../../types/advise';
import { FeatureComparisonRow } from './types';
import { featureNote } from '../../../../utils/adviseMatrix';
import { responseKey, responsesByCell } from '../SideBySideView/SupplierFeatureInput.calc';

/**
 * One row per selected feature, with each supplier's imported answer and the feature's note. An answer is null until the
 * supplier gives one, and while UPSTACK has it flagged, since the report goes to the client.
 */
export const buildFeatureComparison = (
  features: MatrixFeature[],
  suppliers: AdviseSupplier[],
  featureNotes: AdviseEngagement['feature_notes'] | undefined,
  responses: AdviseFeatureResponse[]
): FeatureComparisonRow[] => {
  const cells = responsesByCell(responses);
  return features.map((feature) => {
    const row: FeatureComparisonRow = { feature: feature.label };
    const note = featureNote(featureNotes, feature);
    suppliers.forEach((supplier) => {
      const response = cells.get(responseKey(supplier.id, feature.key));
      row[supplier.id] = { state: response && !response.flagged ? response.state : null, note };
    });
    return row;
  });
};
